import __NS_DYNAMIC_REACT_CONTENT___0 from "./acp-biometrics-introduction.strings/content.default.js";
import { Content, createScopedReactContentImporter } from "packages/react-content/runtime";
const NS_DYNAMIC_REACT_CONTENT_MANAGER = createScopedReactContentImporter(undefined, {
  "default": () => __NS_DYNAMIC_REACT_CONTENT___0
});
import { Body, Title, Disclosure } from 'legos/typography';
import { createElement, Fragment } from 'react';
import { EnrollmentContainer } from './styles/acp-biometrics-intoduction-success-failure.ccm.css';
import { ButtonRaised } from 'legos/button/raised';
import { ButtonFlat } from 'legos/button/flat';
import { ContentBlock } from 'legos/content-block';
import { InPageFlowLayout } from 'legos/in-page-flow-layout';
import { CenterChildren } from '../components';
import { SystemIcon } from 'legos/system-icon';
import { Illustration } from 'legos/illustration';
import { isAndroid, isIOS } from 'packages/platform-detector';
import { SendEventAnalytics } from 'apps/acp/packages/react-analytics';
import { BIOMETRICS_ANALYTICS_CONSTANTS } from '../acp-biometrics-ga-analytics';
import { useSendAnalytics } from 'packages/react-analytics';
import { useHistory } from 'packages/react-nano-router';
export const BiometricsIntroduction = ({
  title,
  biometricsType,
  brand,
  backLinks,
  nextGoLink
}) => {
  const sendAnalytics = useSendAnalytics();
  const history = useHistory();
  const moveBack = {
    /**
     * This will help in capture send analytics event
     * when clicked on InPageFlowLayout back button.
     */
    href: '#',
    onClick: e => {
      e.preventDefault();
      sendAnalytics({
        event: BIOMETRICS_ANALYTICS_CONSTANTS.ACTIONS.WARNING.DISMISS,
        payload: {
          category: BIOMETRICS_ANALYTICS_CONSTANTS.CATEGORY,
          label: BIOMETRICS_ANALYTICS_CONSTANTS.LABEL
        }
      });
      history.replaceState(null, '', backLinks.url());
    }
  };
  return createElement(Fragment, null, createElement(SendEventAnalytics, {
    analyticsEvent: {
      event: BIOMETRICS_ANALYTICS_CONSTANTS.ACTIONS.WARNING.VIEWED,
      payload: {
        category: BIOMETRICS_ANALYTICS_CONSTANTS.CATEGORY,
        label: BIOMETRICS_ANALYTICS_CONSTANTS.LABEL
      }
    }
  }), createElement(InPageFlowLayout, {
    title: title,
    backAnchor: moveBack
  }, createElement(ContentBlock, null, createElement(EnrollmentContainer.div, null, biometricsType === 'touch' && createElement(IntroIconFingerPrint, {
    type: biometricsType
  }), biometricsType === 'face' && createElement(IntroIconFace, null), createElement(Title, null, biometricsType === 'touch' && createElement(Content, {
    hash: "4e993b018a9779ecdbfff951ef0ffa36",
    devVariables: {
      brand: brand
    },
    componentsAndExpressions: [],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  }), biometricsType === 'face' && createElement(Content, {
    hash: "cc05f97841a35897e7ffb13d89492a90",
    devVariables: {
      brand: brand
    },
    componentsAndExpressions: [],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  })), createElement(Body, null, biometricsType === 'touch' && createElement(Content, {
    hash: "3b7340af5bc49400bd536d9707e51479",
    devVariables: {
      brand: brand
    },
    componentsAndExpressions: [],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  }), biometricsType === 'face' && createElement(Content, {
    hash: "c9487bd4a9135984381b080d05b52ab0",
    devVariables: {
      brand: brand
    },
    componentsAndExpressions: [],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  })), createElement(Body, null, createElement(Content, {
    hash: "3770fa7fa4d33000e5b58c5553073ce5",
    devVariables: {},
    componentsAndExpressions: [() => biometricsType === 'touch' ? 'Fingerprint' : 'Face ID', () => biometricsType === 'touch' ? 'fingerprint access' : 'Face ID'],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  })), biometricsType === 'touch' && createElement(Disclosure, null, createElement(Content, {
    hash: "d2b3e266b9a50ddcdb532d8d35a138f6",
    devVariables: {},
    componentsAndExpressions: [],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  })), createElement(CenterChildren, null, createElement(ButtonRaised, {
    color: "positive",
    onClick: () => {
      sendAnalytics({
        event: BIOMETRICS_ANALYTICS_CONSTANTS.ACTIONS.BIOMETRICS_INTRODUCTION.WARNING_GET_STARTED,
        payload: {
          category: BIOMETRICS_ANALYTICS_CONSTANTS.CATEGORY,
          label: BIOMETRICS_ANALYTICS_CONSTANTS.LABEL
        }
      });
      history.replaceState(null, '', nextGoLink.url());
    }
  }, createElement(Content, {
    hash: "2cd2e0c024400be89cb48fe6b0fb783f",
    devVariables: {},
    componentsAndExpressions: [() => biometricsType === 'touch' ? 'Get Started' : 'Close'],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  })), biometricsType === 'touch' && createElement(ButtonFlat, {
    color: "default",
    onClick: () => {
      sendAnalytics({
        event: BIOMETRICS_ANALYTICS_CONSTANTS.ACTIONS.BIOMETRICS_INTRODUCTION.WARNING_CANCEL,
        payload: {
          category: BIOMETRICS_ANALYTICS_CONSTANTS.CATEGORY,
          label: BIOMETRICS_ANALYTICS_CONSTANTS.LABEL
        }
      });
      history.replaceState(null, '', backLinks.url());
    }
  }, createElement(Content, {
    hash: "37626aa8bcb39d0d37840e38c731a651",
    devVariables: {},
    componentsAndExpressions: [],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  }))), biometricsType === 'face' && createElement(Disclosure, null, createElement(Content, {
    hash: "070a5dc7ffbd095a09e32b5e0f9f2324",
    devVariables: {},
    componentsAndExpressions: [],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  }))))));
};

const IntroIconFingerPrint = ({
  type
}) => {
  return createElement(Fragment, null, type === 'touch' && isAndroid() && createElement(SystemIcon, {
    type: "fingerprintAndroid",
    color: "primary",
    size: 9
  }), type === 'touch' && isIOS() && createElement(SystemIcon, {
    type: "fingerprint",
    color: "primary",
    size: 9
  }));
};

const IntroIconFace = () => createElement(Illustration, {
  type: "face-id",
  label: "image illustrating face id"
});